import { Form, Input, message, Modal } from "antd";
import { customerApi } from "api/customer.api";
import { AppSelect } from "components/antd-ui";
import { REJECT_REASON_OTHER, rejectReasonOptions } from "config/customerStage";
import { useCallback, useEffect, useState } from "react";
import { Customer } from "types/customer";

type CustomerRejectModalProps = {
  customer?: Customer;
  onClose: () => void;
  onDone: () => void;
};

// Đánh dấu khách từ chối (khi chưa có cơ hội): chọn lý do chuẩn, lý do "Khác" phải ghi tay
export const CustomerRejectModal = ({ customer, onClose, onDone }: CustomerRejectModalProps) => {
  const [reason, setReason] = useState<string>();
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (customer) {
      setReason(undefined);
      setNote("");
    }
  }, [customer]);

  const handleOk = useCallback(async () => {
    if (!customer) return;
    if (!reason) {
      message.warning("Chọn lý do từ chối");
      return;
    }
    if (reason === REJECT_REASON_OTHER && !note.trim()) {
      message.warning("Nhập lý do từ chối");
      return;
    }
    setSaving(true);
    try {
      await customerApi.reject(customer.id, { reason, note: note.trim() });
      message.success("Đã đánh dấu khách từ chối");
      onDone();
    } finally {
      setSaving(false);
    }
  }, [customer, note, onDone, reason]);

  return (
    <Modal
      open={!!customer}
      title={`Khách từ chối${customer ? ` - ${customer.name}` : ""}`}
      okText="Xác nhận"
      cancelText="Hủy"
      confirmLoading={saving}
      onOk={handleOk}
      onCancel={onClose}
      destroyOnClose
    >
      <Form layout="vertical">
        <Form.Item label="Lý do từ chối" required>
          <AppSelect value={reason} onChange={(value) => setReason(String(value))} options={rejectReasonOptions} placeholder="Chọn lý do" />
        </Form.Item>
        <Form.Item label={reason === REJECT_REASON_OTHER ? "Lý do khác (bắt buộc)" : "Ghi chú thêm"}>
          <Input.TextArea rows={3} maxLength={500} showCount value={note} onChange={(event) => setNote(event.target.value)} />
        </Form.Item>
      </Form>
    </Modal>
  );
};
